/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 *
 * Manages fields, a replacement for JSON Schema.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "appid",
    title: "App ID",
    description: "A Universe application identifier. Supports GUID values and namespace-style IDs.",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    tests: {
        validGuid: {
            must: true,
            run: function () {
                return validate({}, "275d3e76-6de1-4355-af15-ac3704ade1bc");
            }
        },
        validNamespace: {
            must: true,
            run: function () {
                return validate({}, "universe.home");
            }
        },
        invalid: {
            throw: "fields.appid.invalid",
            run: function () {
                return validate({}, "not an app id");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid App ID",
            description: "App ID must be a valid GUID or namespace string.",
            template: "Invalid app id: '${value}'"
        }
    }
});

var guidPattern = /^(?:\{{0,1}(?:[0-9a-fA-F]){8}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){12}\}{0,1}|[0-9a-fA-F]{32})$/;
var namespacePattern = /^[a-z_$][a-z0-9_$]*(\.[a-z_$][a-z0-9_$]*)*$/i;

function validate(spec, value) {
    if (typeof value !== "string") {
        _.errors.invalid.throw({ value: value });
    }

    if (!guidPattern.test(value) && !namespacePattern.test(value)) {
        _.errors.invalid.throw({ value: value });
    }
}
module.exports.validate = validate;
